module.exports = __webpack_public_path__ + "img/图3.249bb193.png";